import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import VueMeta from 'vue-meta';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import GlobalContactForm from './components/GlobalContactForm.vue';

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(ElementUI);

// Register global components
Vue.component('GlobalContactForm', GlobalContactForm);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
